import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Download } from 'lucide-react';
import { getCuestionariosSaludStats } from '@lib/services/cuestionarios-salud.service';
import { ExportModal } from '@components/ExportModal';
import { CardsSkeleton } from '@components/medicus-ui/Loaders';

function fmt(n: number): string {
  return n.toLocaleString('es-AR');
}

export function CuestionariosSaludPage() {
  const [abierto, setAbierto] = useState(false);

  const q = useQuery({
    queryKey: ['cuestionarios-salud-stats'],
    queryFn: getCuestionariosSaludStats,
    refetchInterval: 60_000,
  });

  return (
    <section>
      <header className="pageHeader">
        <h1 className="heading-3">Cuestionarios de salud</h1>
      </header>

      {q.isLoading && (
        <div style={{ marginTop: 24 }}>
          <CardsSkeleton count={3} />
        </div>
      )}
      {q.isError && (
        <p className="status status-error" style={{ marginTop: 24 }}>
          No se pudieron cargar los contadores.
        </p>
      )}

      {q.data && (
        <>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: 16,
              marginTop: 24,
            }}
          >
            <BigCard label="Legajos" value={fmt(q.data.legajosElegibles)} />
            <BigCard label="Cuestionarios" value={fmt(q.data.ddjjCompletadas)} />
            <BigCard label="Con Preexistencias" value={fmt(q.data.personasConPreexistencias)} />
          </div>

          <section style={{ marginTop: 28 }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => setAbierto(true)}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600 }}
            >
              <Download size={16} strokeWidth={2.4} />
              Descargar Excel
            </button>
          </section>
          {abierto && (
            <ExportModal
              tipo="cuestionarios-salud"
              titulo="Cuestionarios de salud"
              onClose={() => setAbierto(false)}
            />
          )}
        </>
      )}
    </section>
  );
}

function BigCard(props: { label: string; value: string }) {
  return (
    <article className="card" style={{ padding: 16 }}>
      <p className="text-element-mid" style={{ fontSize: 12, marginBottom: 4 }}>
        {props.label}
      </p>
      <strong style={{ fontSize: 28, fontVariantNumeric: 'tabular-nums', lineHeight: 1.1 }}>
        {props.value}
      </strong>
    </article>
  );
}
